import makeSettingsReducer from 'app/common/reducers/settings/makeSettingsReducer';


const jobplacesDefaultState = {
  rows: 10,
};

export default makeSettingsReducer('jobplaces', jobplacesDefaultState);
